import { styled } from '@mui/material/styles'

// material-ui(v5)
export const DrawerHeader = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
}))
